import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'


import useStyles from './alert-files.style'

import { FILE_MODAL_OPEN } from '../../redux/actions/types'

import { Image, Video } from '@omnilert/components'
import ImageViewer from '../image-viewer/image-viewer'


const AlertFiles = ({ media }) => {
  const dispatch = useDispatch()

  const [isExpanded, setIsExpanded] = useState(false)

  const handleOnClickShowImage = () => {
    setIsExpanded(prev => !prev)
  }

  const classes = useStyles({ isExpanded })
  
  const handleSetFilesModal = (expandedFile) => {
    dispatch({ type: FILE_MODAL_OPEN, payload: { expandedFile } })
  }

  const mediaType = media.data ? media.data : media

  return (
    <div className={classes.imageWrapper}>
      <button
        className={classes.expandButton}
        onClick={handleOnClickShowImage}
      >{isExpanded ? 'Hide Attachments' : 'Show Attachments'}
      </button>
      <div className={classes.files}>
        {mediaType?.map((datum, i) => {
          // Items without a type are treated as images
          switch (datum.type || 'image') {
          case 'image':
            return (
              <div
                key={i}
                className={classes.imageContainer}
              >
                <ImageViewer>
                  <Image
                    className={classes.image}
                    src={datum.url}
                    thumbnail
                  />
                </ImageViewer>
              </div>
            )
          case 'video':
            return (
              <div
                key={i}
                className={classes.videoContainer}
                onClick={() => handleSetFilesModal(datum)}
              >
                <Video
                  className={classes.video}
                  controls={false}
                  media={datum}
                />
              </div>
            )
          default:
            return null
          }
        }
        )}
      </div>
    </div>
    
  )
}

AlertFiles.defaultProps = {
  media: null
}

AlertFiles.propTypes = {
  media: PropTypes.object
}

export default AlertFiles

